<section class="clinical-trials-wrapper">
  <div class="title-container Auto_Clinical_Details_Title" (click)="open=!open">
    <span class="title">{{trials.length}} clinical trials matches</span>
    <span class="arrow glyphicon glyphicon-chevron-up" *ngIf="trials.length>0"
          [ngClass]="{open:open}"></span>
  </div>
  <ng-container *ngIf="open">
    <ul class="clinical-trial">
      <li class="item" *ngFor="let trial of trials">
        <div class="trial-title">
          <span class="trial-title-text">{{trial.name}}</span>
        </div>
        <section class="labels-container">
          <div class="meta-data" *ngFor="let data of metaData">
            <label>{{data.label}}</label>
            <span>{{getDataFromKey(trial,data.key)}}</span>
          </div>
        </section>
        <span class="trial-link Auto_Trial_Link {{trial.trialID}}" (click)="openReferance(trial.trialID)">
          <span class="icon icon__Link"></span>
          <span class="Auto_Trial_ID">{{trial.trialID}}</span>
          <span class="status-text Auto_Trial_Recruit" *ngIf="trial?.status">{{trial.status}}</span>
        </span>
        <span class="trial-phase Auto_Trial_Phase {{trial.trialID}}" *ngIf="trial.phase  || (trial.phases && trial.phases.length > 0 )">
          <span class="icon__clock"></span>
          <span class="Spacebox__l-tiny bold  Auto_Trial_Phase_Text">{{(trial.phase  || trial.phases.join(', '))}}</span>
        </span>
      </li>
    </ul>
  </ng-container>
</section>
